import { render, staticRenderFns } from "./rightBlock.vue?vue&type=template&id=92765570&scoped=true"
import script from "./rightBlock.vue?vue&type=script&lang=js"
export * from "./rightBlock.vue?vue&type=script&lang=js"
import style0 from "./rightBlock.vue?vue&type=style&index=0&id=92765570&prod&lang=scss&scoped=true"
import style1 from "./rightBlock.vue?vue&type=style&index=1&id=92765570&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92765570",
  null
  
)

export default component.exports